const imageModules = import.meta.glob<{ default: string }>("../assets/pre-login/*/*.png", { eager: true });

type OnboardingImageSet = {
	schedule: string;
	tradeShift: string;
	tip: string;
	news: string;
	messages: string;
};

const get = (langCode: string, filename: string): string => {
	const fallbackLangCode = "en";
	const fallback = `../assets/pre-login/${fallbackLangCode}/${filename}`;

	const key = `../assets/pre-login/${langCode}/${filename}`;
	return (imageModules[key] ?? imageModules[fallback]).default;
};

export const getOnboardingImages = (language: string): OnboardingImageSet => {
	const langCode = new Intl.Locale(language).language;
	return {
		schedule: get(langCode, "Schedule.png"),
		tradeShift: get(langCode, "TradeShift.png"),
		tip: get(langCode, "Tip.png"),
		news: get(langCode, "News.png"),
		messages: get(langCode, "Messages.png"),
	};
};
